import { Outlet } from 'react-router';

const IntegrationLayout = () => <Outlet />;

export default IntegrationLayout;
